import { PaymentMethodFormStages } from "./paymentMethod";
import lookups from "./lookups";
import { PastYearsSelectHeader } from "../components/elements/DateSelectHeader";

export const PaymentMethodsFormStages = [
  {
    title: "Payment Methods",
    sections: [
      {
        name: "",
        table: {
          allowAdd: true,
          allowEdit: true,
          allowStatusEdit: true,
          fields: [
            {
              name: "g4b_paymenttype",
              className: "col-short-name",
            },
            {
              name: "g4b_cardprovider",
              className: "col-short-name",
            },
            {
              name: "g4b_chippinprovider",
              className: "col-short-name",
            },
            {
              name: "g4b_voucherprovider",
              className: "col-short-name",
            },
            {
              name: "createdon",
              className: "col-date",
              type: "datetime",
            },
            {
              name: "modifiedon",
              className: "col-date",
              type: "datetime",
            },
          ],
          filterByStatus: true,
          filters: [
            {
              name: "g4b_paymenttype",
              type: "select",
            },
            {
              name: "g4b_cardprovider",
              type: "select",
            },
            {
              name: "g4b_chippinprovider",
              type: "select",
            },
            {
              name: "g4b_voucherprovider",
              type: "select",
            },
            {
              name: "createdon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
            {
              name: "modifiedon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
          ],
          linkForNewRecord: "/payment-method",
          lookup: lookups.g4b_paymentmethod.all,
          subFormStages: PaymentMethodFormStages,
          useAlphabetPagination: true,
          useSubForm: false,
        },
      },
    ],
  },
];
